// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import PartReturns, {getDefaultState as getPartReturnsDefaultState} from '../../shared/state/part-returns';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const AllPartRequestsState = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    partReturns: PartReturns,
    searchFilters: SearchFilters
}, 'AllPartRequestsState');

export const getDefaultState = () =>
    new AllPartRequestsState({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        partReturns: getPartReturnsDefaultState(),
        searchFilters: getSearchFiltersDefaultState()
    });

export default AllPartRequestsState;



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/state/index.js